export const TEXTS = {
  ADD_TARGET: "Add new target",
  EDIT_TARGET: "Edit target",
  MODAL_HEADER: "Edit target devices",
  GROUP_ALL: "All from #{group}",
  PLATFORM_TYPE_CONFLICT_MESSAGE:
    "You can not select devices from different platform types.",
  TARGET_ALL: "All",
  TARGET_HEADER: "Target",
  TARGET_NONE: "None",
  TOGGLE_ALL: "Toggle all",
};

export const TARGET_FIELDS = {
  platforms: { label: "Platform", name: "platforms" },
  oems: { label: "OEM", name: "oems" },
  clientTypes: { label: "Client", name: "clientTypes" },
};
